var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "wallet-banner"
  }, [_c('div', {
    staticClass: "d-flex align-items-start"
  }, [_c('div', {
    staticClass: "me-4"
  }, [_c('img', {
    staticClass: "profile-pic",
    attrs: {
      "src": "/assets/images/wallet/profile-pic.png",
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "flex-grow-1 ml-4"
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-3"
  }, [_c('img', {
    staticClass: "country-flag",
    attrs: {
      "src": "/assets/images/wallet/INDIA.png",
      "alt": ""
    }
  }), _c('h2', {
    staticClass: "user-name me-3 mb-0"
  }, [_vm._v("John Anderson")]), _c('span', {
    staticClass: "badge ml-4"
  }, [_c('img', {
    staticClass: "pending-sign",
    attrs: {
      "src": "/assets/images/wallet/pending.png",
      "alt": "In progress"
    }
  }), _vm._v(" verification in progress ")])]), _c('div', {
    staticClass: "row balance-info p-3 align-items-center"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h3', {
    staticClass: "total mb-2"
  }, [_vm._v("Total Balance")]), _c('p', {
    staticClass: "balance-value mb-3"
  }, [_vm._v("0.000000 BTC")]), _c('p', {
    staticClass: "usd-value mb-4"
  }, [_vm._v("= $0.00 USD")])])]), _c('p', {
    staticClass: "update-date mt-2"
  }, [_vm._v("Last updated: Today, 14:45 PM")])])])]), _c('div', {
    staticClass: "overview-section"
  }, [_c('h5', {
    staticClass: "ml-3 mb-3"
  }, [_vm._v("Overview")]), _c('div', {
    staticClass: "row g-4"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "overview-card p-4 d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('p', {
    staticClass: "card-heading mb-3"
  }, [_vm._v("Total Withdrawals")]), _c('h4', {
    staticClass: "mb-3 fw-bold num-value"
  }, [_vm._v(" 0.00 "), _c('span', {
    staticClass: "text-secondary"
  }, [_vm._v("BTC")])]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("+0.00")])]), _c('div', {
    staticClass: "icon-circle bg-light"
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/wallet/withdraws.png",
      "alt": "withdraw icon",
      "width": "24"
    }
  })])])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "overview-card p-4 d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('p', {
    staticClass: "card-heading mb-3"
  }, [_vm._v("Pending Requests")]), _c('h4', {
    staticClass: "mb-3 fw-bold num-value"
  }, [_vm._v("0")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("0 Processing")])]), _c('div', {
    staticClass: "icon-circle bg-light"
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/wallet/pending-request.png",
      "alt": "pending icon",
      "width": "24"
    }
  })])])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "overview-card p-4 d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('p', {
    staticClass: "card-heading mb-3"
  }, [_vm._v("Completed Transactions")]), _c('h4', {
    staticClass: "mb-3 fw-bold num-value"
  }, [_vm._v("0")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("This month")])]), _c('div', {
    staticClass: "icon-circle bg-light"
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/wallet/right-check.png",
      "alt": "completed icon",
      "width": "24"
    }
  })])])])])])]);
}]

export { render, staticRenderFns }